import { fieldStyle } from '../dashboards/primitives';
import { Field } from '../dashboards/primitives/Field';
import { LocationRegionField } from '../dashboards/primitives/LocationRegionField';

import ClientAddressFields from './steps/ClientAddressFields';
import LocationModeToggle from './steps/LocationModeToggle';
import { COLUMN, NOTE, requiredProps } from './steps/step-layout';
import TimeZoneConfirmation from './steps/TimeZoneConfirmation';
import VenueSelectField from './steps/VenueSelectField';
import WorkshopTypeDateTimeFields from './steps/WorkshopTypeDateTimeFields';
import type { WhenWhatForm as Form } from './use-when-what-form';

/** The inline When & what form: the create drawer's date, type and
 *  three-way location controls, plus the headcount. */
export default function WhenWhatForm({ form }: { form: Form }) {
  const { fields, set, fieldError } = form;
  const headcountError = fieldError('headcount');
  return (
    <div style={COLUMN}>
      <WorkshopTypeDateTimeFields form={form} />
      {fields.endDate && fields.endDate !== fields.date && (
        <p style={NOTE}>Ends the following day, {fields.endDate}.</p>
      )}
      <Field
        label="Headcount"
        required
        error={headcountError}
        hint={<span style={NOTE}>never locked</span>}
      >
        <input
          aria-label="Headcount"
          {...requiredProps(headcountError)}
          inputMode="numeric"
          value={fields.headcount}
          onChange={(e) => set('headcount', e.target.value)}
          style={fieldStyle(headcountError ? 'error' : undefined, { maxWidth: 120 })}
        />
      </Field>
      <LocationRegionField
        mode="open"
        regions={form.regions}
        loading={form.regionsLoading}
        failed={form.regionsFailed}
        value={fields.regionId}
        label=""
        error={fieldError('regionId')}
        onChange={form.setRegion}
      />
      <LocationModeToggle form={form} />
      {fields.locationMode === 'venue' && <VenueSelectField form={form} />}
      {fields.locationMode === 'client-site' && <ClientAddressFields form={form} />}
      {fields.locationMode !== 'venue' && <TimeZoneConfirmation form={form} />}
      <p style={NOTE}>
        {fields.locationMode === 'venue'
          ? 'Times are the venue’s local clock.'
          : 'Times are the event’s local clock.'}
      </p>
    </div>
  );
}
